<button
  class="btn btn-success-soft support-dashboard-download-trigger"
  id="supportDashboardDownloadBtn"
  type="button"
  [attr.disabled]="disabled ? true : null"
  (click)="toggleDownloadMenu($event)"
>
  Download
  <i class="fa fa-caret-down" aria-hidden="true"></i>
  <div
    class="support-dashboard-download-menu"
    [class.open]="isDownloadMenuOpen"
  >
    <div class="dropdown-item" (click)="exportPDFTrigger($event)">
      PDF
    </div>
    <div class="dropdown-item" (click)="exportXlsxTrigger($event)">
      XLSX
    </div>
  </div>
</button>
